import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { UserProfileState } from 'app/services';

export const userProfileRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const userProfileState = inject(UserProfileState);
    const isAdminProfile = !!route.data['adminProfile'];
    userProfileState.setIsAdminProfile(isAdminProfile);
    return true;
};
